 function quickExit() {
    localStorage.clear();
    sessionStorage.clear();
    document.body.style.display = 'none';
    window.open("https://www.google.com", "_newtab");
    window.location.replace('https://www.google.com');
    e.preventDefault();
}

 var cybertipReport = {
    uploader: null,
    maxuploadsize:0,
    avatar : null,
    module:'cybertiplinereports',
    data : {
       report_category:null,
       report_location_type:null,
       skip_step_3:false,
       currentStep:1,
       file_ids:[],
       step_1:[],
       step_2:[],
       step_3:[],
       step_4:[],
    },

     init:function(t){
        var $this = this;

        
        cybertipReport.data.currentStep = $(t).data('step') || 1;

        $(t+" .next").click(function(){
  			    cybertipReport.submitStep($(this));
  		  });

  		$(t+ " .previous").click(function(){
  			  var $form_data = $('#cybertipline_form_'+cybertipReport.data.currentStep).serializeArray();
              cybertipReport.data['step_'+cybertipReport.data.currentStep] = $form_data;

               if(cybertipReport.data.currentStep==2 && cybertipReport.data['step_2'].filter(function( element ) {return element.name === 'incident_date';}).length>0 ){
                 var $date_vale = cybertipReport.data['step_2'].filter(function( element ) {
                                 return element.name === 'incident_date';
                               })[0]['value'];
                   cybertipReport.data['step_2'].filter(function( element ) {
                                 return element.name === 'incident_date';
                               })[0]['value']= $date_vale.replace('Οκτωβρίου', 'October').replace('Νοεμβρίου', 'November').replace('Δεκεμβρίου', 'December').replace('Ιανουαρίου', 'January').replace('Φεβρουαρίου', 'February').replace('Μαρτίου', 'March').replace('Απριλίου', 'April').replace('Μαΐου', 'May').replace('Ιουνίου', 'June').replace('Ιουλίου', 'July').replace('Αυγούστου', 'August').replace('Σεπτεμβρίου', 'September');

               }
  			   cybertipReport.previousStep($(this));
  			
  		});

       $('.cybertipline-step.step-2 input[name="other_information"]').change(function(){
         if($(this).val()=='yes'){
            cybertipReport.data.skip_step_3 =false;
         }else{
           cybertipReport.data.skip_step_3 =true;
         }
       });
        

       var incident_target, complainant_age;


      $(t+ ' select[name="category"]').change(function(){
          var target = $('#incident-category-description-wrapper');
            var request_data = {category:$(this).val()};

             cybertipReport.data.report_category = $(this).val();

             var content =  $('#incident-category-description-wrapper').data('ajax-content');


             $('#incident-category-description-wrapper').load(content, request_data ,function(){
           });
      });


      $(t+ ' select[name="incident_location"]').change(function(){
          var target = $('#incident-location-fields-wrapper');
          var request_data = {incident_location:$(this).val()};

          cybertipReport.data.report_location_type = $(this).val();
          var content =  $('#incident-location-fields-wrapper').data('ajax-content');

           cybertipReport.data.file_ids =[];
           cybertipReport.maxuploadsize=0;
           if(cybertipReport.uploader!==null && typeof(cybertipReport.uploader.files)!=='undefined' && typeof(cybertipReport.uploader.files)!==null && cybertipReport.uploader.files.length>0){
            for(var $i in cybertipReport.uploader.files){
               

                 $.ajax({url:WS_ROOT+'?module=cybertiplinereports&action=remove_upload&filename='+cybertipReport.uploader.files[$i]['target_name'],success:function(data){
                    cybertipReport.uploader.removeFile(cybertipReport.uploader.files[$i]['id']);
                }});
            }
           }
          
         $('#incident-location-fields-wrapper').load(content, request_data ,function(){
             if($('#uploader-container').length){
                 cybertipReport.uploaderinit('uploader');
            }

            
           if( cybertipReport.report_location_type !=='Physical'){
            
           }
        });
         
      });

       $(t+ ' input[name="authority_reported"]').change(function(){
         if($(this).val()=='no'){
           $('.cybertipline-step.step-4 .public-authority-group').hide();

            $('.cybertipline-step.step-4 .public-authority-group').find('select').each(function(){  
             $(this).val(null).trigger('change')
           });

             $('.cybertipline-step.step-4 .contact-details-group').find('.contact_id_number_input').removeAttr('required');
             $('.cybertipline-step.step-4 .contact-details-group .contact_id_number_input').closest('.form-group').find('.asterix').attr('style','display: none');
         

         }else{
           $('.cybertipline-step.step-4 .public-authority-group').show();
           $('.cybertipline-step.step-4 .public-authority-group').find('select').each(function(){  
             $(this).attr('required','required');
           });

           $('.cybertipline-step.step-4 .contact-details-group').find('.contact_id_number_input').attr('required','required');
           $('.cybertipline-step.step-4 .contact-details-group .contact_id_number_input').closest('.form-group').find('.asterix').attr('style','display: inline');

           

         }

       });


       $(t+ ' input[name="complain_by_name"]').change(function(){
         if($(this).val()=='no'){
           $('.cybertipline-step.step-4 .contact-details-group').hide();

            $('.cybertipline-step.step-4 .contact-details-group').find('select').each(function(){  
             $(this).val(null).trigger('change')
           });

            $('.cybertipline-step.step-4 .contact-details-group').find('input:not(.contact_id_number_input)').each(function(){  
             $(this).val('').removeAttr('required');
           });

         }else{
           $('.cybertipline-step.step-4 .contact-details-group').show();

            $('.cybertipline-step.step-4 .contact-details-group').find('input:not(.contact_id_number_input)').each(function(){  
             $(this).attr('required','required');
           });
         }

       });


        $(t+ ' input[name="complainant_incident_target"]').change(function(){
           var target = $('#incident-complainant-information');
           var request_data = {complainant_incident_target:$(this).val()};
           incident_target = $(this).val();
           var content =  target.data('ajax-content');
            target.load(content, request_data ,function(){
                    target.find('input[name="complainant_age"]').change(function(){
                      complainant_age = $(this).val();
                        if($(this).val()=='I am over 18 years old'){
                            target.find('input[name="complainant_incident_spoken"]').removeAttr('required');
                            target.find('input[name="complainant_incident_spoken"]').prop('checked',false);
                            target.find('.complainant_incident_spoken-wrapper').hide(); 
                        }else{
                            target.find('input[name="complainant_incident_spoken"]').attr('required','required');
                            target.find('.complainant_incident_spoken-wrapper').show();
                        }

                        if(($(this).val()=='I am over 18 years old') && (incident_target !='To me')) {
                          target.find('input[name="complainant_underage"]').removeAttr('required');
                          target.find('input[name="complainant_underage"]').prop('checked',false);
                          target.find('.complainant_underage-wrapper').hide();
                        } else if(($(this).val()=='I am over 18 years old') && (incident_target =='To me')) {
                           target.find('input[name="complainant_underage"]').attr('required','required');
                          target.find('.complainant_underage-wrapper').show();
                        }
                 
                     });
            });

       });

      
      $('.datetimepicker').each(function(){
         $(this).datetimepicker({
          //maxDate: new Date(),
              sideBySide: true,
              locale:LANGUAGE_CODE ,
              format:"DD MMMM YYYY HH:mm"
          });
      });

      $('.select2').each(function(){
         $(this).select2({
          templateResult: function (data, container) {
            if(data.element) {
              $(container).addClass($(data.element).attr("class"));
         }
          return data.text;
          }
      });
      });


    },
     submitStep:function($caller){
        $.extend($.validator.messages, {
            required: locale['This field is required.'] || 'This field is required.',
            email: locale['Please enter a valid email address.'] || 'Please enter a valid email address.',
            number:  locale['Please enter a valid number.'] || "Please enter a valid number.",
            digits: locale['Please enter only digits.'] || "Please enter only digits.",
            creditcard: locale['Please enter a valid credit card number.'] || "Please enter a valid credit card number.",
            equalTo: locale['Please enter the same value again.'] || "Please enter the same value again.",
            maxlength: locale['Please enter no more than {0} characters.'] || "Please enter no more than {0} characters.",
            minlength:locale['Please enter at least {0} characters.'] || "Please enter at least {0} characters.",
            rangelength:locale['Please enter a value between {0} and {1} characters long.'] || "Please enter a value between {0} and {1} characters long.",
            range:locale['Please enter a value between {0} and {1}.'] || "Please enter a value between {0} and {1}.",
            max:locale['Please enter a value less than or equal to {0}.'] || "Please enter a value less than or equal to {0}.",
            min:locale['Please enter a value greater than or equal to {0}.'] || "Please enter a value greater than or equal to {0}."
        });

          if($('#cybertipline_form_'+cybertipReport.data.currentStep).length && $('#cybertipline_form_'+cybertipReport.data.currentStep).validate({
             lang: 'fi',
             submitHandler: function() {  
              },
           
              errorPlacement: function(error, element) {
                if(element.attr('type') =='text' || element.attr('type') =='email' || element.attr('type') =='number'){
                     error.insertAfter(element);
                }

              },
              highlight: function (element, errorClass, validClass) {
                  $(element).closest('.form-group').find("label").addClass('error-checkbox'); 
              },
              unhighlight: function (element, errorClass, validClass) {
                  $(element).closest('.form-group').find("label").removeClass('error-checkbox'); 
              }

           }).form()){


                var $form_data = $('#cybertipline_form_'+cybertipReport.data.currentStep).serializeArray();
                   cybertipReport.data['step_'+cybertipReport.data.currentStep] = $form_data;

                   if(cybertipReport.data.currentStep==2 && cybertipReport.data['step_2'].filter(function( element ) {return element.name === 'incident_date';}).length>0 ){
                     var $date_vale = cybertipReport.data['step_2'].filter(function( element ) {
                                     return element.name === 'incident_date';
                                   })[0]['value'];
                       cybertipReport.data['step_2'].filter(function( element ) {
                                     return element.name === 'incident_date';
                                   })[0]['value']= $date_vale.replace('Οκτωβρίου', 'October').replace('Νοεμβρίου', 'November').replace('Δεκεμβρίου', 'December').replace('Ιανουαρίου', 'January').replace('Φεβρουαρίου', 'February').replace('Μαρτίου', 'March').replace('Απριλίου', 'April').replace('Μαΐου', 'May').replace('Ιουνίου', 'June').replace('Ιουλίου', 'July').replace('Αυγούστου', 'August').replace('Σεπτεμβρίου', 'September');

                   }

                    if(  cybertipReport.data.skip_step_3 ){
                      cybertipReport.data.step_3 =[];
                    }
                 
                  cybertipReport.nextStep($caller);

           
          }
      


    },
    nextStep:function( $caller ){
       if( cybertipReport.data.skip_step_3 && cybertipReport.data.currentStep==2 ){
            cybertipReport.data.currentStep = 4;
            cybertipReport.loadStep($caller.closest('.cybertipline-step').data('bypass-next-ajax-content'));
         }else{
            cybertipReport.data.currentStep = Number(cybertipReport.data.currentStep+1);
             cybertipReport.loadStep($caller.closest('.cybertipline-step').data('next-ajax-content'));
         }
      scroll2element('#cybertipline-step-wrapper');
       

    },
     previousStep:function( $caller ){
         if( cybertipReport.data.skip_step_3 && cybertipReport.data.currentStep==4 ){
            cybertipReport.data.currentStep = 2;
             cybertipReport.loadStep($caller.closest('.cybertipline-step').data('bypass-prev-ajax-content'));
         }else{
            cybertipReport.data.currentStep = Number(cybertipReport.data.currentStep-1);
             cybertipReport.loadStep($caller.closest('.cybertipline-step').data('prev-ajax-content'));
         }
          scroll2element('#cybertipline-step-wrapper');
         

    },
    loadStep:function( content ){
         var target = $('#cybertipline-step-wrapper');

          if(cybertipReport.data.currentStep==3){

             if( cybertipReport.data['step_3'].filter(function( element ) {return element.name === 'report_category';}).length==0){
                cybertipReport.data['step_3'].push({name: 'report_category', value:  cybertipReport.data.report_category });
             }else{
               cybertipReport.data['step_3'].filter(function( element ) {return element.name === 'report_category';})[0]['value'] =  cybertipReport.data.report_category;
             }

              if( cybertipReport.data['step_3'].filter(function( element ) {return element.name === 'report_location_type';}).length==0){
                 cybertipReport.data['step_3'].push({name: 'report_location_type', value:  cybertipReport.data.report_location_type });
             }else{
               cybertipReport.data['step_3'].filter(function( element ) {return element.name === 'report_location_type';})[0]['value'] =  cybertipReport.data.report_location_type;
             }

             
           
         }
        


         if(cybertipReport.data.currentStep==5){
           var request_data = cybertipReport.data;
         }else{
           var request_data = cybertipReport.data['step_'+cybertipReport.data.currentStep];
         }
         

         $('#cybertipline-step-wrapper').load(content, request_data ,function(){
            cybertipReport.init('.cybertipline-step.step-'+cybertipReport.data.currentStep);



              if(cybertipReport.data.currentStep==1){
                   var request_data =  cybertipReport.data['step_1'];
                   var content =   $('#incident-complainant-information').data('ajax-content');
                   var target = $('#incident-complainant-information');

                    $('#incident-complainant-information').load(content, request_data ,function(){

                        target.find('input[name="complainant_age"]').change(function(){
                        if($(this).val()=='I am over 18 years old'){
                           
                            target.find('input[name="complainant_incident_spoken"]').removeAttr('required');
                            target.find('input[name="complainant_incident_spoken"]').prop('checked',false);
                             target.find('.complainant_incident_spoken-wrapper').hide();
                           
                            target.find('input[name="complainant_underage"]').attr('required','required');
                            target.find('.complainant_underage-wrapper').show();
                            
                        }else{
                             target.find('input[name="complainant_underage"]').removeAttr('required');
                            target.find('input[name="complainant_underage"]').prop('checked',false);
                            target.find('.complainant_underage-wrapper').hide();
                            target.find('input[name="complainant_incident_spoken"]').attr('required','required');
                            target.find('.complainant_incident_spoken-wrapper').show();
                            
                        }
                     });
                  
                    });

              }

              if(cybertipReport.data.currentStep==2){

                 var request_data = cybertipReport.data['step_2'];
                 var content =  $('#incident-category-description-wrapper').data('ajax-content');
                 $('#incident-category-description-wrapper').load(content, request_data ,function(){});

                  var content_location =  $('#incident-location-fields-wrapper').data('ajax-content');

                     $('#incident-location-fields-wrapper').load(content_location, request_data ,function(){
                        if($('#uploader-container').length){
                            cybertipReport.uploaderinit('uploader');
                        }


                       if( cybertipReport.report_location_type !=='Physical'){
                        
                       }
                    });
                 
              }

              if(cybertipReport.data.currentStep==3){
                $('.optional-required').trigger('change');
              }

              

        });

    },
     submitReport:function(){

      $("#cyberlink-submit-report-btn").attr("disabled", "disabled");
        $.ajax({url:WS_ROOT,data:{module:cybertipReport.module,action:'save_cybertiplinereports', form_data:cybertipReport.data },success:function(data){

            if(data.status === 'ok'){
                form_submit_response('.cybertipline','success',data.message,true);
              
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            }else if(data.status === 'error') {
                form_submit_response('.cybertipline','error',data.error);
                $("#cyberlink-submit-report-btn").removeAttr("disabled");
            }else{
                form_submit_response('.cybertipline','error','An unknown error occured. Please try again later');
                $("#cyberlink-submit-report-btn").removeAttr("disabled");
            }
        }});
     },
     uploaderinit : function(target){

            var $this = this;

            cybertipReport.uploader = new plupload.Uploader({
                runtimes        : 'html5',
                browse_button   : target + '-pickfiles',
                container       : target + '-container',
                drop_element    : target + '-dropzone',
                headers:{
                    'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                multiple:true,
                url : WS_ROOT+'?module=cybertiplinereports&action=upload&dataType=json',
                unique_names : true,
                filters : {
                    max_file_size : '8mb',
                    mime_types: [
                         {title : "Images", extensions : "jpg,jpeg,png"}
                    ]
                }
            });

             var uploader = cybertipReport.uploader;



            $('#'+target + '-uploadfiles').click(function(e) {
                uploader.start();
                e.preventDefault();
            });


             uploader.init();

             uploader.bind('FilesAdded', function(up, files) {

                up.refresh();

                $.each(up.files, function(i, file) {

                    if(  cybertipReport.data.file_ids.filter(function( element ) {return element === file.id;}).length==0 && uploader.total.size < 8874368 ){
                        cybertipReport.data.file_ids.push(file.id);
                        var $target_name= '';
                        if(typeof(file.type)!=='undefined'){
                            var $ext =file.type.split('/');
                            if($ext.length>1){
                                 $target_name = file.id+'.'+$ext[1];
                            }
                            
                        }
                       
                       
                        var markup = '  <div  id="' + file.id + '" class="clearfix" style="margin-top:10px">\
                                    <p style="float:left;text-overflow: ellipsis;overflow: hidden;">'+file.name+'<br/>' + plupload.formatSize(file.size) + '</p>\
                                    <div class="progress progress-small" style="display:none;height:6px;">\
                                        <div class="progress-bar progress-bar-danger" style="    background-color: rgb(34, 137, 233);width: 0%;"></div>\
                                    </div>\
                                    <a href="#" onclick="$(\'#' + file.id + '\').remove();cybertipReport.removeFileFromUploader(\''+file.id+'\','+file.size+',\''+$target_name+'\');return false;" style="width:14px;display:block;float:right;color:#b82528" class="btn-link remove-uploaded-file "><i class="fa fa-trash" aria-hidden="true"></i></a>\
                                    </div>';
                   
                       $('#'+target + '-uploaded-files').append(markup);
                    }
                        
                  
                });
                up.refresh();

                 
                uploader.start();

            });

             uploader.bind('QueueChanged', function(up) {

               if(uploader.total.size > 8874368) {
                    if(up.files.length > 0) {
                     for(var i=0;i<up.files.length;i++) {
                        if(  cybertipReport.data.file_ids.filter(function( element ) {return element === up.files[i].id;}).length==0  ){
                         cybertipReport.maxuploadsize += up.files[i].size;
                             if( cybertipReport.maxuploadsize  > 8874368) {
                                cybertipReport.maxuploadsize -= up.files[i].size;
                                uploader.removeFile(up.files[i].id);  
                                up.refresh();
                             }
                         }
                     }

                  }
                  up.refresh();
                  var $text_exceed =locale['Files size exceeded 8MB'] || "Files size exceeded 8MB";
                  form_submit_response('#'+target + '-uploadfiles' ,'error',  $text_exceed );
               }
            });

             cybertipReport.uploader.bind('UploadProgress', function(up, file) {
                $('#' + file.id + " .progress").fadeIn('fast');
                $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
            });

             cybertipReport.uploader.bind('Error', function(up, err) {
              form_submit_response('#'+target + '-uploadfiles' ,'error', "Message: " + err.message + (err.file ? ", File: " + err.file.name : "") );
                up.refresh();

            });

             cybertipReport.uploader.bind('FileUploaded', function(up, file,ee) {

                var response = (JSON.parse(ee.response));
                $('#' + file.id ).append('<input type="hidden" value="'+file.id+'"    name="uploads['+file.id+'][id]" >');
                $('#' + file.id ).append('<input type="hidden" value="'+file.target_name+'"    name="uploads['+file.id+'][file]" >');
                $('#' + file.id ).append('<input type="hidden" value="'+file.name+'"    name="uploads['+file.id+'][filename]" >');
                $('#' + file.id ).append('<input type="hidden" value="'+plupload.formatSize(file.size)+'"  name="uploads['+file.id+'][formatted_size]" >');
                $('#' + file.id ).append('<input type="hidden" value="'+file.size+'"  name="uploads['+file.id+'][filesize]" >');

                $('#' + file.id + " .progress").fadeOut('fast');
                $this.avatar = file.name;
                
            });


        },
     removeFileFromUploader : function($file_id, $size,$filename){
         $.ajax({url:WS_ROOT+'?module=cybertiplinereports&action=remove_upload&filename='+$filename,success:function(data){
            cybertipReport.uploader.removeFile($file_id);  
            cybertipReport.uploader.refresh();
            cybertipReport.maxuploadsize -=  $size;
            cybertipReport.data.file_ids = cybertipReport.data.file_ids.filter(function( element ) {return element != $file_id;});
        }});

     }




}